export function getDayMonthYear(rawDate: number | Date) {
    const date = new Date(rawDate);
    const [month, day, year] = [date.getMonth() + 1, date.getDate(), date.getFullYear()];
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`
}